import { LayoutDefinitionSchema as LayoutDefinitionSchemaV1 } from "./v1";

/**
 * Every layout definition schema this bundle can validate against, keyed by
 * the version number stamped on records saved under it. A saved record carries
 * that number into storage and other clients read it back, so a key never
 * changes and no number is reused for a different schema.
 *
 * Adding a schema means adding its entry here and raising
 * `LATEST_LAYOUT_SCHEMA_VERSION` in the same change; nothing in the types holds
 * the two together.
 */
const layoutSchemas = new Map([[1, LayoutDefinitionSchemaV1]]);

/**
 * Version stamped on layout definitions the application builds; a definition
 * loaded from storage keeps the version it was read at instead.
 */
export const LATEST_LAYOUT_SCHEMA_VERSION = 1;

export class UnsupportedLayoutSchemaVersion extends Error {
  constructor(schemaVersion: number, options?: ErrorOptions) {
    super(`Schema version ${schemaVersion} is unsupported`, options);
    this.name = "UnsupportedLayoutSchemaVersion";
  }
}

/**
 * Returns the schema that validates a layout definition saved at the given
 * version.
 *
 * @throws {UnsupportedLayoutSchemaVersion} if no schema is registered under
 *   that version, as happens when a stored layout names a version this bundle
 *   does not know.
 */
export function getLayoutSchema(schemaVersion: number) {
  const schema = layoutSchemas.get(schemaVersion);

  if (schema === undefined) {
    throw new UnsupportedLayoutSchemaVersion(schemaVersion);
  }

  return schema;
}
